module.exports = __webpack_public_path__ + "media/images/powerpoint/strategir-background-586f7721944218ccfc312c815d12b38b.png";